import React, { useState, useRef, useEffect } from "react";
import "./recentproject.styles.css";

const singleProject = {
  id: "1",
  header: "Stock Analyzer with MCP + Gemini + yFinance + Claude",
  title: "MCP Server and Agents With Claude",
  description: [
    "This is a sample project to learn how agents work with an MCP server.",
    "It demonstrates how to create an MCP server and client, and how to integrate with Claude so it can use tools from your local server."  
  ],
  bgUrl: "",
  link: "https://github.com/pvyas033/stockanalyzer#readme",
  videoUrl: "demo/stockana.mp4",
  claudeVideoUrl: "demo/claudeset.mp4"
};

const RecentprojectComponent = () => {
  const { description, videoUrl, claudeVideoUrl, link } = singleProject;
  const [activeVideoUrl, setActiveVideoUrl] = useState(null);
  const projectCardRef = useRef(null);
  const [projectCardVisible, setProjectCardVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setProjectCardVisible(true);
        }
      },
      {
        root: null,
        rootMargin: "0px",
        threshold: 0.1,
      }
    );

    if (projectCardRef.current) {
      observer.observe(projectCardRef.current);
    }

    return () => {
      if (projectCardRef.current) {
        observer.unobserve(projectCardRef.current);
      }
    };
  }, []);

  const handlePlayVideo = (url) => (e) => {
    e.preventDefault();
    setActiveVideoUrl(url);
  };

  const handleGoBack = (e) => {
    e.preventDefault();
    setActiveVideoUrl(null);
  };

  return (
    <div className="custom-recent-project-container" ref={projectCardRef}>
      <br/>
      <h3 className="h3">Recent Work</h3>
      <div className={`custom-project-card ${projectCardVisible ? 'visible' : ''}`}>
        {activeVideoUrl ? (
          <div className="video-container">
            <video className="project-video" controls autoPlay>
              <source src={activeVideoUrl} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <button className="close-btn" onClick={handleGoBack}>
              ✖
            </button>
          </div>
        ) : (
          <div className="custom-project-content-overlay">
            <div className="custom-project-logo">
              <span className="project-brand-name">STOCK ANALYZER</span>
            </div>
            <h3 className="custom-project-title-large">{description[0]}</h3>
            <p className="custom-project-description-text">{description[1]}</p>
            <div className="button-container">
              <a href={link} className="custom-view-work-btn" target="_blank" rel="noopener noreferrer">
                Git Repo
              </a>
              <a href={videoUrl} className="custom-view-work-btn" onClick={handlePlayVideo(videoUrl)}>
                CLI Demo
              </a>
              <a href={claudeVideoUrl} className="custom-view-work-btn" onClick={handlePlayVideo(claudeVideoUrl)}>
                Claude Demo
              </a>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default RecentprojectComponent;